import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { each, orderBy, filter } from 'lodash';
import Fa from 'react-fontawesome';
import {
  Dropdown, MenuItem,
} from 'react-bootstrap';

class AutomationSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.selectAutomation = this.selectAutomation.bind(this);
  }

  selectAutomation(automation) {
    this.props.selectAutomation(automation);
  }


  renderAutomatioName(automation) {
    let star = (<Fa name="star" className="invisible" />);
    let name = automation.name;
    if (automation.is_system) {
      star = (<Fa name="star" className="text-warning" />);
    } else if (automation.is_empty) {
      name = (<i>[{automation.name}]</i>);
    }
    return (
      <span className={automation.enabled ? '' : 'text-muted'}>
        {star} {name}
      </span>
    );
  }

  renderResult() {
    const { automation, automations, disabled } = this.props;

    let toggleInner = (<span>select an automation</span>);
    if (automation) {
      toggleInner = this.renderAutomatioName(automation);
    }

    const groupedAutomations = [
      {
        header: 'Opportunity Automations',
        items: filter(automations, { source: 'opportunity' }),
      },
      {
        header: 'Account Automations',
        items: filter(automations, { source: 'account' }),
      },
    ];

    const items = [];

    each(groupedAutomations, (gAutomations, idx) => {
      if (gAutomations.items.length > 0) {
        items.push((
          <MenuItem key={`header-${idx}`} header>{gAutomations.header}:</MenuItem>
        ));
        each(gAutomations.items, (item) => {
          items.push((
            <MenuItem
              active={(automation && automation._id === item._id)}
              key={item._id}
              onSelect={() => { this.selectAutomation(item); }}
            >
              {' '}&nbsp;{' '}&nbsp;{this.renderAutomatioName(item)}
            </MenuItem>
          ));
        });
      }
    });

    return (
      <span>
        <Dropdown
          disabled={disabled}
          id="dropdown-automation"
        >
          <Dropdown.Toggle disabled={disabled}>
            {toggleInner}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {items}
          </Dropdown.Menu>
        </Dropdown>
      </span>
    );
  }

  renderEmpty() {
    return (
      <div className="alert alert-warning">
        No automation group found.
      </div>
    );
  }

  render() {
    const { automations } = this.props;
    if (automations.length > 0) {
      return this.renderResult();
    }
    if (automations.length === 0) {
      return this.renderEmpty();
    }
    return null;
  }
}

AutomationSelector.propTypes = {
  dispatch: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  selectAutomation: PropTypes.func,
  automations: PropTypes.arrayOf(PropTypes.shape({})),
  automation: PropTypes.shape({}),
};
AutomationSelector.defaultProps = {
  selectAutomation: () => {},
  disabled: false,
  automations: [],
  automation: null,
};
AutomationSelector.contextTypes = {
};

function mapStateToProps() {
  return {};
}

export default connect(mapStateToProps)(AutomationSelector);
